export default __webpack_public_path__ + "static/media/student-portfolios.d91be047.png";